import Navigation from 'components/shared/Navigation/Navigation'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Icon, Label, Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationSubmenu extends React.Component {
  render() {
    const { color, items, push, hideSidebar, node } = this.props

    const menuItems = items.map((item) => (
      <Menu.Item
        {...{
          active: item.active,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        {item.badge ? (
          <Label color="red" className="badge">
            {item.badge}
          </Label>
        ) : (
          ''
        )}
        <Icon color={color} name={item.icon} />
        {item.content}
      </Menu.Item>
    ))

    const menu = (
      <Menu.Item>
        <Menu.Header>
          <Navigation render="title" as="text" node={node} />
        </Menu.Header>
        <Menu.Menu size="small">{menuItems}</Menu.Menu>
      </Menu.Item>
    )

    return menuItems ? menu : false
  }
}

NavigationSubmenu = connect(mapStateToProps, mapDispatchToProps)(
  NavigationSubmenu
)
export default NavigationSubmenu



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationSubmenu.jsx